import { ColumnType } from 'antd/es/table';
import { getChangeTypeToChangeLabel } from './@arch/lib';
import React from 'react';
import { SonarText } from '@ui/text';
import { VersionNumber } from '@ui/VersionNumber';
import { When } from 'react-if';
import { convertISODateToShortDate, getSonarObjectTypeAndSourceLabel } from '@sonar-software/sonar-ts-lib';
import { COPY_SPECIFIC, TIMELINE_TABLE_DATA_INDICES } from '@sonar-software/sonar-ts-constants';
import { Space, Tag } from 'antd';
import { TimelineChangeType, TimelineDetailsTableColumnKey, TimelineTableEntry } from '@sonar-software/sonar-core';

type ColumnDefinition = ColumnType<TimelineTableEntry> & {
	key: TimelineDetailsTableColumnKey
};

const dateColumn: ColumnDefinition = {
	key: 'date',
	render: (record) => convertISODateToShortDate(record.change?.timestamp ?? ''),
	sorter: true,
	title: COPY_SPECIFIC.DATE
};

const displayNameColumn: ColumnDefinition = {
	key: 'displayName',
	render: (record) => {
		const { displayName, parentDisplayName, versionNumber } = record;

		return (
			<Space wrap>
				{ displayName }
				<VersionNumber number={ versionNumber } />
				<When condition={ parentDisplayName }>
					<Tag>{ parentDisplayName }</Tag>
				</When>
			</Space>
		);
	},
	sorter: true,
	title: COPY_SPECIFIC.DISPLAY_NAME
};

const objectTypeColumn: ColumnDefinition = {
	dataIndex: TIMELINE_TABLE_DATA_INDICES.SONAR_OBJECT_TYPE,
	key: 'sonarObjectType',
	render: getSonarObjectTypeAndSourceLabel,
	sorter: true,
	title: COPY_SPECIFIC.TYPE
};

const changeTypeColumn: ColumnDefinition = {
	dataIndex: [ 'change', TIMELINE_TABLE_DATA_INDICES.CHANGE_TYPE ],
	key: 'changeType',
	render: (type: TimelineChangeType) =>
		<SonarText className={ type }>{ getChangeTypeToChangeLabel(type) }</SonarText>,
	sorter: true,
	title: COPY_SPECIFIC.CHANGE
};

const modifiedByColumn: ColumnDefinition = {
	dataIndex: TIMELINE_TABLE_DATA_INDICES.LAST_MODIFIED_BY_NAME,
	key: 'modifiedBy',
	sorter: true,
	title: COPY_SPECIFIC.MODIFIED_BY
};

export function getTimelineDetailColumns(): Array<ColumnDefinition> {
	return [ dateColumn, displayNameColumn, objectTypeColumn, changeTypeColumn, modifiedByColumn ];
}
